export default {
  methods: {
    emitError(e, stat) {
      let statuses = stat
      statuses = statuses || [400, 403, 404, 409]
      if (statuses.some((s) => s === e.response.status)) {
        return e.response.data.message
      }
      this.$emit('error', e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ErrorEmiter.js